const FieldText = (props: any) => {
    return (
        <div className="text__container">
            {props.Comentario}
        </div>
    )
}

export default FieldText;